import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import ParametersTab from './ParametersTab';
import EmployeesTab from './EmployeesTab';
import IntegrationsTab from './IntegrationsTab';
import ClientsTab from './ClientsTab';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function Settings() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Settings
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Parameters" />
          <Tab label="Employees" />
          <Tab label="Clients" />
          <Tab label="Project Sources" />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <ParametersTab />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <EmployeesTab />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <ClientsTab />
        </TabPanel>

        <TabPanel value={currentTab} index={3}>
          <IntegrationsTab />
        </TabPanel>
      </Paper>
    </Box>
  );
}

export default Settings;